import { EFilterType } from 'shared/enums/EFilterType';
import { hasWorkplaceOfficeType } from 'shared/utils/filters/hasWorkplaceOfficeType';
import { isRent } from 'shared/utils/filters/isRent';
import { isSingleOfficeType } from 'shared/utils/filters/isSingleOfficeType';

import { IFiltersService } from '../IFiltersService';

import { AbstractFiltersService } from './AbstractFiltersService';

export class RentWorkplaceFiltersService extends AbstractFiltersService implements IFiltersService<EFilterType> {
  public isAvailable(): boolean {
    return isRent(this.filters) && isSingleOfficeType(this.filters) && hasWorkplaceOfficeType(this.filters);
  }

  public getFields(): EFilterType[] {
    return super.getFields().concat(EFilterType.workplaceType, EFilterType.workplaceCount, EFilterType.price);
  }
}
